import { Text, View } from "@react-pdf/renderer";
import React from "react";

// Utility function to convert camelCase to regular text
const normalizeText = (camelCase) => {
  return camelCase
    .replace(/([A-Z])/g, " $1") // Insert a space before all caps
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
};

export default function Info({ styles, data, label }) {
  // Get the table headers from the first object keys in the sampleData
  const headers = data && data.length > 0 ? Object.keys(data[0]) : "";

  return (
    <View>
      {label ? (
        <View style={{ marginBottom: 10 }}>
          <View style={{ display: "flex", flexDirection: "row", gap: ".06in" }}>
            <Text>{label}: </Text>
            <Text style={{ color: "red" }}>{data?.length || 0}</Text>
          </View>
        </View>
      ) : null}
      {data && data.length > 0 ? (
        <View style={styles.table}>
          {/* Dynamic Table Header */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            {headers.map((header, index) => (
              <View key={index} style={styles.tableCol}>
                <Text style={{ ...styles.tableCell, fontWeight: "bold" }}>
                  {normalizeText(header)}
                </Text>
              </View>
            ))}
          </View>

          {/* Dynamic Table Data */}
          {data.map((item, rowIndex) => (
            <View key={rowIndex} style={styles.tableRow}>
              {headers.map((key, colIndex) => (
                <View key={colIndex} style={styles.tableCol}>
                  <Text style={styles.tableCell}>{item[key]}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
      ) : data ? (
        <Text style={{ color: "red", marginTop: ".1in" }}>
          No Records Found
        </Text>
      ) : null}
    </View>
  );
}
